<section class="grid" role="region" aria-labelledby="sponsor-details-heading">
	<section class="column" role="region">
		<h3 id="main-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">apartment</mat-icon>
			<span>{{ 'sponsor.details.sponsor' | transloco }}</span>
		</h3>

		<section class="info" aria-labelledby="main-heading">
			<p class="name">{{ sponsor().name }}</p>
		</section>

		<h3 id="address-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">location_on</mat-icon>
			<span>{{ 'sponsor.details.address' | transloco }}</span>
		</h3>

		<address aria-labelledby="address-heading">
			<p [attr.aria-label]="'base.field.street_address' | transloco">
				{{ sponsor().address?.streetAndHouseNumber || ('global_search.unknown' | transloco) }}
			</p>
			<p [attr.aria-label]="'base.field.postal_code_and_city' | transloco">
				{{ sponsor().address?.postalCodeAndCity || ('global_search.unknown' | transloco) }}
			</p>
		</address>
	</section>

	<section class="column" role="region">
		<h3 id="communication-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">phone_in_talk</mat-icon>
			<span>{{ 'sponsor.details.communication' | transloco }}</span>
		</h3>

		<section class="communication" aria-labelledby="communication-heading">
			<p class="label">{{ 'sponsor.details.preferred_communication' | transloco }}</p>
			@if (preferredCommunicationWay()) {
				@if (preferredCommunicationWay()!.categoryContactPointId === 1) {
					<p>
						<a [href]="'tel:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else if (preferredCommunicationWay()!.categoryContactPointId === 2) {
					<p>
						<a [href]="'mailto:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else {
					<p>{{ preferredCommunicationWay()!.contactValue }}</p>
				}
				<p>{{ preferredCommunicationWay()!.remark }}</p>
			} @else {
				<p>{{ 'institution.persons.no_contact_points' | transloco }}</p>
			}

			@if (communicationWays().length >= 1) {
				<cdk-accordion lvrPadding [padHorizontal]="0" [padVertical]="0">
					<cdk-accordion-item #accordionItem="cdkAccordionItem">
						<button
							matButton
							class="trailing-icon-button"
							(click)="accordionItem.toggle()"
							tabindex="0"
							[attr.id]="'accordion-header'"
							[attr.aria-expanded]="accordionItem.expanded"
							[attr.aria-controls]="'accordion-body'"
						>
							<span class="label">{{ 'sponsor.details.more_communication' | transloco }}</span>
							@if (accordionItem.expanded) {
								<mat-icon>keyboard_arrow_up</mat-icon>
							} @else {
								<mat-icon>keyboard_arrow_down</mat-icon>
							}
						</button>
						@if (accordionItem.expanded) {
							<section
								role="region"
								[style.display]="accordionItem.expanded ? '' : 'none'"
								[attr.id]="'accordion-body'"
								[attr.aria-labelledby]="'accordion-header'"
							>
								@for (cp of communicationWays(); track cp.id) {
									<div lvrBorder borderPosition="bottom" lvrPadding [padHorizontal]="8" [padVertical]="0">
										@if (cp.categoryContactPointId === 1) {
											<p>
												<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
											</p>
										} @else if (cp.categoryContactPointId === 2) {
											<p>
												<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
											</p>
										} @else {
											<p>{{ cp.contactValue }}</p>
										}
										<p style="margin-top: 16px">{{ cp.remark }}</p>
									</div>
								}
							</section>
						}
					</cdk-accordion-item>
				</cdk-accordion>
			}
		</section>
	</section>
</section>
